import {getSportsContentConfigs} from './style/sports-content.js';

export function getTokens() {
    return getSportsContentConfigs();
}
